import { API_PUBLIC_HOST } from "@/_constant";
import api from "./request";

export function registerLead(listingId, latitude, longitude, metadata={}){
    return new Promise(async (resolve, reject) => {
        try {
            let url = `${API_PUBLIC_HOST}/lead/registerLead?listId=${listingId}`;
            if(latitude && longitude) {
                url += `&latitude=${latitude}&longitude=${longitude}`;
            }
            const res = await api.post(url, metadata);
            resolve(res);
        } catch(err){
            reject(err);
        }
    });
}